import styled from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { boxPropExclusions } from '../Box/props.js';
import { mapBoxPropValues } from '../Box/utils.js';
import { styles } from '../constants/styles.js';

var logoContainer = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__logoContainer",
  componentId: "sc-3ec22c-0"
})(["", " svg{flex-shrink:0;}", ""], function (props) {
  return mapBoxPropValues(props.$size, function (value, breakpoint) {
    var sizeProp = value;
    var sizings = props.theme.fortumLogo.web.sizings[sizeProp];
    switch (breakpoint) {
      /**
       * The default non-responsive styles
       */
      case undefined:
      case 'default':
        return "padding: ".concat(sizings.paddingVertical, " ").concat(sizings.paddingHorizontal, " ").concat(sizings.paddingVertical, " ").concat(sizings.paddingHorizontal, ";\n            \n            svg {\n              height: ").concat(sizings.logoHeight, ";\n\n            }");
      /**
       * Return a breakpoint-specific style
       */
      default:
        return "".concat(styles.breakpoint[breakpoint], " { padding: ").concat(sizings.paddingVertical, " ").concat(sizings.paddingHorizontal, " ").concat(sizings.paddingVertical, " ").concat(sizings.paddingHorizontal, ";\n            svg {\n              height: ").concat(sizings.logoHeight, ";\n\n             }\n            }");
    }
  });
}, boxStyles);

export { logoContainer };
